import { useEffect, useRef, useState } from 'react'
import { useParams, useLocation, useNavigate } from 'react-router-dom'
import { Box, Tab, Tabs, Alert, Paper } from '@mui/material';

import TabTransactionList from './components/TabTransactionList';
import TabTransactionForm from './components/TabTransactionForm';

const Transactions = () => {

	const { type } 										= useParams();
	const location 										= useLocation();
	const navigate 										= useNavigate();

	const [displaySuccessAlert, setDisplaySuccessAlert]	= useState(false)
	const [displayErrorAlert, setDisplayErrorAlert]		= useState(false)
	const [message, setMessage]							= useState()	

	const [currentTabIndex, setCurrentTabIndex]			= useState(0);	
	const [initialTicker, setInitialTicker]				= useState(null);
	const stateConsumedRef 								= useRef(false);

	useEffect(() => {
		if (location.state) {
			setCurrentTabIndex(location.state?.openTab === 1 ? 1 : 0);
			setInitialTicker(location.state?.initialTicker || null);
			stateConsumedRef.current = true;
			navigate(location.pathname, { replace: true, state: null });
			return;
		}
		if (stateConsumedRef.current) {
			stateConsumedRef.current = false;
			return;
		}
		
		// fallback padrão quando não vem state (ex.: troca de rota /type)
		setCurrentTabIndex(0);
		setInitialTicker(null);
	}, [location.state, location.pathname, navigate, type]);

 	const handleTabChange = (e, tabIndex) => {
	  setCurrentTabIndex(tabIndex);
	};

	return (
		<Paper sx={{martinTop:0, martinBottom:4, marginLeft: 2, marginRight: 4, minHeight:'88vh'}} elevation={1}>

			<Box margin={1}>
				<Tabs value={currentTabIndex} onChange={handleTabChange} aria-label="basic tabs example">
					<Tab label="Transações"/>
					<Tab label="Adicionar Nova"/>
				</Tabs>

				{ displaySuccessAlert ? <Alert severity="success" onClose={() => {setDisplaySuccessAlert(false)}} sx={{m:1}}>{message}</Alert> : null }
				{ displayErrorAlert ? <Alert severity="error" onClose={() => {setDisplayErrorAlert(false)}} sx={{m:1}}>{message}</Alert> : null }

				{/* TAB 1 - Listagem */}
				{currentTabIndex === 0 && (
					<TabTransactionList 
						type={type} 
						setDisplaySuccessAlert={setDisplaySuccessAlert} 
						setDisplayErrorAlert={setDisplayErrorAlert} 
						setMessage={setMessage} 
						setCurrentTabIndex={setCurrentTabIndex}
					/>
				)}	

				{/* TAB 2 - Formulario */}
				{currentTabIndex === 1 && (
					<TabTransactionForm 
						type={type}
						setDisplaySuccessAlert={setDisplaySuccessAlert} 
						setDisplayErrorAlert={setDisplayErrorAlert} 
						setMessage={setMessage} 
						setCurrentTabIndex={setCurrentTabIndex}
						initialTicker={initialTicker}				
					/>
				)}					
			</Box>

		</Paper>
		
	)
}


export default Transactions
